module.exports = __webpack_public_path__ + "img/lingwoyun_logo.97e1b640.png";